/**
 * Default template IDs for resale-related email notifications.
 * These IDs correspond to predefined email templates.
 */
export const DEFAULT_TEMPLATE_IDS = {
    TICKET_ON_RESALE: 78239,
    TICKET_RESOLD: 78240,
    RESALE_SHARE_LINK: 78241
};

/**
 * Default identity configuration for email sending in resale contexts.
 * This represents Weezevent's default sender identity, used when no custom identity is set.
 */
export const DEFAULT_IDENTITY = {
    id: 3664,
    organizer: 0,
    from_address: {
        name: 'Weezevent',
        email: 'support@weezevent.com'
    },
    reply_to: {
        name: 'Weezevent',
        email: 'no-reply@weezevent.com'
    },
    media: 'email'
};

/**
 * Processes template data to organize templates into categorized lists for resale settings.
 */
export const getTemplatesLists = data => {
    const { custom_templates = [], default_templates = {} } = data.response || {};

    return {
        onResale: [...custom_templates, default_templates[DEFAULT_TEMPLATE_IDS.TICKET_ON_RESALE]],
        resold: [...custom_templates, default_templates[DEFAULT_TEMPLATE_IDS.TICKET_RESOLD]],
        resale: [...custom_templates, default_templates[DEFAULT_TEMPLATE_IDS.RESALE_SHARE_LINK]]
    };
};

/**
 * Generates options for template selection dropdowns, marking default templates appropriately.
 */
export const getTemplateOptions = (templates, t) => {
    return templates.map(template => {
        const isDefault = Object.values(DEFAULT_TEMPLATE_IDS).includes(template.id);
        return {
            key: template.id,
            text: isDefault ? t('ticket.resales.settings.notifications.default_template') : template.name,
            value: template.id
        };
    });
};
